import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { IconSpinner, NamedRedirect, Page } from '../../components';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { ListingPageParamTab } from './EditListingPage.utils';
import { ListingPageParamType } from '../../util/urlHelpers';
import { EditListingPageParams, EditListingPageState } from './EditListingPage.duck';
import ItemDetailsForm from './ItemDetailsForm';
import SearchForm from './SearchForm';
import { AboutPageTab } from '../AboutPage/aboutPageUtils';
import { ITEM_AVAILABILITY_PURCHASED } from '../../util/constants';
import { useEnabledCustomerExperiences } from '../../hooks/useEnabledCustomerExperiences';
import { useOwnListingVersions } from './hooks/useOwnListingVersions';

const Loading: FC = () => (
  <Box display="flex" justifyContent="center" py={2}>
    <IconSpinner />
  </Box>
);

interface EditListingPageProps {
  params: EditListingPageParams;
}

const EditListingPage: FC<EditListingPageProps> = (props) => {
  const { params } = props;
  const { isShopClosed } = useEnabledCustomerExperiences();

  const { slug, id, type, tab } = params;

  const intl = useIntl();
  const scrollingDisabled = useSelector<any>((state) => isScrollingDisabled(state));
  const { fetchListingError } = useSelector<any>(
    (state) => state.EditListingPage
  ) as EditListingPageState;
  const { savedListing } = useOwnListingVersions();

  const isNewURI = type === ListingPageParamType.New;
  const isDraftURI = type === ListingPageParamType.Draft;
  const isNewListingFlow = isNewURI || isDraftURI;

  if (isShopClosed) {
    return <NamedRedirect name="AboutPage" params={{ tab: AboutPageTab.Info }} />;
  }

  if (!Object.values(ListingPageParamTab).includes(tab)) {
    const redirectedTab =
      type === ListingPageParamType.New ? ListingPageParamTab.Search : ListingPageParamTab.Details;
    return <NamedRedirect name="EditListingPage" params={{ slug, id, type, tab: redirectedTab }} />;
  }

  const isPurchased =
    savedListing?.attributes.publicData?.availability === ITEM_AVAILABILITY_PURCHASED;
  if (fetchListingError || isPurchased) {
    return <NamedRedirect name="ListingPage" params={{ id, slug }} />;
  }

  const title = isNewListingFlow
    ? intl.formatMessage({ id: 'EditListingPage.titleCreateListing' })
    : intl.formatMessage({ id: 'EditListingPage.titleEditListing' });

  let body;
  switch (tab) {
    case ListingPageParamTab.OrderNumber:
    case ListingPageParamTab.Search:
    case ListingPageParamTab.CannotFind:
    case ListingPageParamTab.ListAnyBrand:
      body = <SearchForm />;
      break;
    case ListingPageParamTab.Details:
      body = <ItemDetailsForm />;
      break;
    default:
      body = <Loading />;
      break;
  }

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      {body}
    </Page>
  );
};

export default EditListingPage;
